export class OpenWorkEvent {
    workId: string;
    reference: number;
    type: string;
}
